module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manager-track-report center-panel report"
  }, [_c('md-content', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    attrs: {
      "md-theme": "white"
    }
  }, [_c('sort-table', {
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": _vm.dealsAmount,
      "table-id": "report",
      "default-order": "desc",
      "default-sort": "id",
      "showAddButton": false
    },
    on: {
      "refresh": _vm.getDeals
    },
    scopedSlots: _vm._u([{
      key: "first_freight",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "no-break-text"
        }, [_vm._v(" " + _vm._s((scope.item.first_freight && scope.item.first_freight.traking_number) ? scope.item.first_freight.traking_number : 'Не установлен') + " ")])]
      }
    }, {
      key: "created_at",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "no-break-text"
        }, [_vm._v(" " + _vm._s((scope.item.created_at && scope.item.created_at) ? _vm.moment(scope.item.created_at).format('DD MMM YYYY') : 'Не установлен') + " ")])]
      }
    }, {
      key: "payer",
      fn: function(scope) {
        return [(scope.item.payer && scope.item.payer.name) ? _c('span', [_vm._v(" " + _vm._s(scope.item.payer.name) + " ")]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }, {
      key: "recipient",
      fn: function(scope) {
        return [(scope.item.recipient && scope.item.recipient.name) ? _c('span', [_vm._v(" " + _vm._s(scope.item.recipient.name) + " ")]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }, {
      key: "bill",
      fn: function(scope) {
        return [(scope.item.documents && scope.item.documents.length) ? _c('div', [(_vm.hasDocs(scope.item, 'bill')) ? _c('div', [_vm._v(" Да ")]) : _c('div', [_vm._v(" Нет ")])]) : _vm._e(), _vm._v(" "), (!scope.item.documents || !scope.item.documents.length) ? _c('div', [_vm._v(" Нет ")]) : _vm._e()]
      }
    }, {
      key: "invoice",
      fn: function(scope) {
        return [(scope.item.documents && scope.item.documents.length) ? _c('div', [(_vm.hasDocs(scope.item, 'invoice')) ? _c('div', [_vm._v(" Да ")]) : _c('div', [_vm._v(" Нет ")])]) : _vm._e(), _vm._v(" "), (!scope.item.documents || !scope.item.documents.length) ? _c('div', [_vm._v(" Нет ")]) : _vm._e()]
      }
    }, {
      key: "assignment",
      fn: function(scope) {
        return [(scope.item.documents && scope.item.documents.length) ? _c('div', [(_vm.hasDocs(scope.item, 'assignment')) ? _c('div', [_vm._v(" Да ")]) : _c('div', [_vm._v(" Нет ")])]) : _vm._e(), _vm._v(" "), (!scope.item.documents || !scope.item.documents.length) ? _c('div', [_vm._v(" Нет ")]) : _vm._e()]
      }
    }, {
      key: "recepit",
      fn: function(scope) {
        return [(scope.item.documents && scope.item.documents.length) ? _c('div', [(_vm.hasDocs(scope.item, 'recepit')) ? _c('div', [_vm._v(" Да ")]) : _c('div', [_vm._v(" Нет ")])]) : _vm._e(), _vm._v(" "), (!scope.item.documents || !scope.item.documents.length) ? _c('div', [_vm._v(" Нет ")]) : _vm._e()]
      }
    }, {
      key: "act",
      fn: function(scope) {
        return [(scope.item.documents && scope.item.documents.length) ? _c('div', [(_vm.hasDocs(scope.item, 'act')) ? _c('div', [_vm._v(" Да ")]) : _c('div', [_vm._v(" Нет ")])]) : _vm._e(), _vm._v(" "), (!scope.item.documents || !scope.item.documents.length) ? _c('div', [_vm._v(" Нет ")]) : _vm._e()]
      }
    }, {
      key: "stock_note",
      fn: function(scope) {
        return [(scope.item.documents && scope.item.documents.length) ? _c('div', [(_vm.hasDocs(scope.item, 'stock_note')) ? _c('div', [_vm._v(" Да ")]) : _c('div', [_vm._v(" Нет ")])]) : _vm._e(), _vm._v(" "), (!scope.item.documents || !scope.item.documents.length) ? _c('div', [_vm._v(" Нет ")]) : _vm._e()]
      }
    }, {
      key: "route_list",
      fn: function(scope) {
        return [(scope.item.documents && scope.item.documents.length) ? _c('div', [(_vm.hasDocs(scope.item, 'route_list')) ? _c('div', [_vm._v(" Да ")]) : _c('div', [_vm._v(" Нет ")])]) : _vm._e(), _vm._v(" "), (!scope.item.documents || !scope.item.documents.length) ? _c('div', [_vm._v(" Нет ")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.deals),
      callback: function($$v) {
        _vm.deals = $$v
      },
      expression: "deals"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa9764f4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/reports/views/MissingDocumentsReport.vue
// module id = 1282
// module chunks = 0